import { gnp_estatus } from "../../constants/gnp_cons";
import {
  URL_ASISTENCIA_DESTINO,
  URL_BASE,
  URL_BASE_ASISTENCIAS,
  URL_CABINA_ASIGNACION,
  URL_CABINA_USUARIO_ASIGNACION,
  URL_EDEGA_ENVIAR_DOCUMENTO,
  URL_GET_ACEPTACION_NOTIFICACION,
  URL_NOTIFICACIONES_SMS,
  URL_BASE_PROVEEDORES,
  URL_SOLICITUD_NOTIFICACIONES_ASISTENCIA_WA,
  URL_UTILIDADES,
} from "../../constants/url";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";
import { get, getFile, post, postFile } from "../../utils/fetch";
import { types } from "../types/types";
import { startUpdateServicioGnp } from "./gnpApiActions";
import { notification } from "./notificationActions";
import { hdiTipoFechas, putNotification } from "./hdiActions";

const loadingDatosDrawer = (estado) => ({
  type: types.setLoadingDatosDrawer,
  payload: estado,
});

const storeCorralones = (data) => ({
  type: types.storeCorralones,
  payload: data,
});

const storeTalleres = (data) => ({
  type: types.storeTalleres,
  payload: data,
});

export const startLoadDirectorioCorralones = () => {
  return async (dispatch) => {
    dispatch(loadingDatosDrawer(true));
    const url = `${URL_UTILIDADES}/GsDbConsultas/GetDirectorioSubastaSegura`;
    const result = await get(url);
    if (result.code === 0) {
      dispatch(storeCorralones(result.data));
    } else {
      dispatch(notification(composeErrorNotification("Error al cargar corralones", result.error)));
    }
    dispatch(loadingDatosDrawer(false));
  };
};

export const startSearchTalleres = (termino) => {
  return async (dispatch) => {
    dispatch(loadingDatosDrawer(true));
    dispatch(storeTalleres([]));
    if (!termino) {
      dispatch(loadingDatosDrawer(false));
      return;
    }
    const url = `${URL_UTILIDADES}/GsDbConsultas/GetDatosTallerAgencia/${termino}`;
    const result = await get(url);
    if (result.code === 0) {
      dispatch(storeTalleres(result.data));
    } else {
      dispatch(notification(composeErrorNotification("Error al buscar talleres", result.error)));
    }
    dispatch(loadingDatosDrawer(false));
  };
};

//////////
export const startLoadAsistencia = (asistenciaID, mostrarLoading = true) => {
  return async (dispatch) => {
    if (mostrarLoading) dispatch(setLoadingDetalle(true));

    const result = await get(
      `${URL_BASE_ASISTENCIAS}/GetAsistencia/${asistenciaID}`
    );
    if (result.code === 0) {
      dispatch(storeAsistencia(result.data));
      dispatch(startLoadSucursalesByServicio(result.data.servicioID));
      dispatch(startGetHistorial(asistenciaID));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexión - Get asistencia",
            `${result.error}`
          )
        )
      );
    }
    dispatch(setLoadingDetalle(false));
  };
};

const setLoadingDetalle = (estado) => ({
  type: types.setLoadingDetalle,
  payload: estado,
});
export const storeAsistencia = (data) => ({
  type: types.storeAsistencia,
  payload: data,
});
const storeAceptacionNotificacion = (data) => ({
  type: types.storeAceptacionNotificacion,
  payload: data,
});
export const clearAceptacionNotificacion = () => ({
  type: types.clearAceptacionNotificacion,
});
export const setFolderPagina = (pagina) => ({
  type: types.setFolderPagina,
  payload: pagina,
});

export const startGetAceptacionNotificacion = (asistenciaID, mostrarError = true) => {
  return async (dispatch) => {
    const result = await get(`${URL_GET_ACEPTACION_NOTIFICACION}/${asistenciaID}`);

    if (result.code === 0) {
      dispatch(storeAceptacionNotificacion(result.data));
    } else if (mostrarError === true) {
      dispatch(
        notification(
          composeErrorNotification("Error al validar aceptación", `${result.error}`)
        )
      );
    }

    return result;
  };
};

export const startEnviarMensajeTexto = (body) => {
  return async (dispatch) => {
    const result = await post(URL_NOTIFICACIONES_SMS, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Mensaje enviado correctamente")));
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al enviar mensaje", `${result.error}`)
        )
      );
    }

    return result;
  };
};

export const startSolicitudNotificacionesAsistenciaWA = (body) => {
  return async (dispatch) => {
    const result = await post(URL_SOLICITUD_NOTIFICACIONES_ASISTENCIA_WA, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Plantilla WhatsApp enviada")));
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al enviar plantilla WhatsApp", `${result.error}`)
        )
      );
    }

    return result;
  };
};

export const startEnviarDocumentoEdega = (nombre, file) => {
  return async (dispatch, getState) => {
    const { asistenciaID } = getState().detalleReducer.asistencia;
    const formData = new FormData();

    formData.append("AsistenciaID", asistenciaID);
    formData.append("Nombre", nombre);
    formData.append("File", file);

    const result = await postFile(URL_EDEGA_ENVIAR_DOCUMENTO, formData);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Documento enviado")));
      return true;
    }

    dispatch(
      notification(
        composeErrorNotification(
          "Error al enviar documento Edega",
          `${result.error}`
        )
      )
    );
    return false;
  };
};

export const actualizacionCostoMasivo = async (file, proveedorID) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("proveedorID", proveedorID);

  return postFile(
    `${URL_BASE_PROVEEDORES}/ActualizacionCostoMasivo`,
    formData
  );
};

export const clearProveedorCostos = () => ({
  type: types.clearProveedorCostos,
  payload: null,
});
///

export const startLoadSucursalesByServicio = (servicioID) => {
  return async (dispatch) => {
    const result = await get(
      `${URL_BASE_ASISTENCIAS}/GetSucursalesByServico/${servicioID}`
    );
    if (result.code === 0) {
      dispatch(storeSucursalesByServicio(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - GetSucursalesByServico",
            `${result.error}`
          )
        )
      );
    }
  };
};

const storeSucursalesByServicio = (sucursales) => ({
  type: types.storeSucursalesByServicio,
  payload: sucursales,
});

/////////////////////////////////

export const startEstablecerCita = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/EstablecerCita`;

    const result = await post(url, body);
    console.log(body);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
      return true;
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Establecer cita",
            `${result.error}`
          )
        )
      );
      return false;
    }
  };
};

export const startQuitarCita = (asistenciaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/QuitarCita/${asistenciaID}`;

    const result = await get(url);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Establecer cita",
            `${result.error}`
          )
        )
      );
    }
  };
};

/////////////////////////////////
export const startSetStep = () => {
  return async (dispatch, getState) => {
    const { asistenciaID, folioGnp, esGnpApi, estatusID } =
      getState().detalleReducer.asistencia;

    const url = `${URL_BASE_ASISTENCIAS}/AvanzaStep/${asistenciaID}`;

    const result = await post(url);
    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID, false));

      if (esGnpApi) {
        if (estatusID === 3)
          // 3=proveedor asignado, enviamos arribo
          dispatch(
            startUpdateServicioGnp({
              folioAsignacion: folioGnp,
              estatusActual: gnp_estatus.ARRIBO.clave,
            })
          );
        if (estatusID === 5)
          // 5=contacto asignado, enviamos termiando
          dispatch(
            startUpdateServicioGnp({
              folioAsignacion: folioGnp,
              estatusActual: gnp_estatus.TERMINADO.clave,
            })
          );
      }
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Avanza step",
            `${result.error}`
          )
        )
      );
    }
  };
};

/////

export const marcarArriboSigsa = (body) => {
  return async (dispatch, getState) => {
    const { asistenciaID, folioGnp, esGnpApi } =
      getState().detalleReducer.asistencia;

    const url = `${URL_BASE_ASISTENCIAS}/MarcarArribo`;
    const result = await post(url, { ...body, asistenciaID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      dispatch(startLoadAsistencia(asistenciaID, false));

      if (esGnpApi) {
        // enviamos a GNP
        dispatch(
          startUpdateServicioGnp({
            folioAsignacion: folioGnp,
            estatusActual: gnp_estatus.ARRIBO.clave,
          })
        );
      }
    } else {
      dispatch(
        notification(
          composeErrorNotification(
        "Error",
            `${result.error}`
          )
        )
      );
    }
  };
};

////
export const startPostProveedor = (body) => {
  return async (dispatch, getState) => {
    //
    const { nombre, usuarioID } = getState().userReducer.user;
    const { proveedorSucursalID } = getState().detalleReducer.proveedorCostos;
    // TODO:  post hdi-proveedor
    // const url = `${URL_BASE_ASISTENCIAS}/AsignaProveedor`;
    const url = `${URL_CABINA_ASIGNACION}/AsignaProveedor2`;
    const result = await post(url, {
      ...body,
      proveedorSucursalID,
      usuarioID,
      usuario: nombre,
    });
    //
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));

      if (body.estaAsignado && body.esGnpApi)
        dispatch(
          startUpdateServicioGnp({
            folioAsignacion: body.folioGnp,
            estatusActual: gnp_estatus.EN_ATENCION.clave,
          })
        );


    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
      dispatch(startLoadAsistencia(body.asistenciaID, false));
    }
  };
};

/// actualiza a gnp

export const startActualizaServicioGnp = (estatusActual) => {
  return async (dispatch, getState) => {
    const { folioGnp, tiempoArribo } = getState().detalleReducer;

    const url = `${URL_BASE_ASISTENCIAS}/AsignaProveedor`;
    const body = {
      estatusActual,
      folioGnp,
      tiempoArribo,
    };

    const result = await post(url, body);

    //
    if (result.code === 0) {
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion startActualizaServicioGnp"
          )
        )
      );
    }
  };
};

/////////////////////////////////////////////////////

export const startGetAsistenciasByValidador1 = () => {
  return async (dispatch, getState) => {
    const { validador1 } = getState().detalleReducer.asistencia.asegurado;
    const url = `${URL_BASE_ASISTENCIAS}/GetAsistenciasByValidador1/${validador1}`;

    const result = await get(url);
    if (result.code === 0) {
      dispatch(storeAsistenciasByValidador1(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Avanza step",
            `${result.error}`
          )
        )
      );
    }
  };
};

const storeAsistenciasByValidador1 = (asistencias) => ({
  type: types.storeAsistenciasByValidador1,
  payload: asistencias,
});
/////////////////////////////////////////////////////

export const startPostConcluirServicio = (body) => {
  return async (dispatch) => {
    //

    const url = `${URL_BASE_ASISTENCIAS}/ConcluirServicio`;
    const result = await post(url, body);

    //
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));

      // Concluir el servicio para HDI (lógica de hdi en la función)
      if (body.estatusFinal === 2 || body.estatusFinal === 3) {
        dispatch(putNotification(hdiTipoFechas.fechaTermino, body));
      }
      // Cancelar el servicio para HDI (lógica de hdi en la función)
      if (body.estatusFinal === 4 || body.estatusFinal === 5) {
        dispatch(putNotification(hdiTipoFechas.fechaCancelado, body));
      }

      if (body.esGnpApi) {
        if (body.estatusFinal === 2 || body.estatusFinal === 3)
          // concluido y otorgado
          dispatch(
            startUpdateServicioGnp({
              folioAsignacion: body.folioGnp,
              estatusActual: gnp_estatus.TERMINADO.clave,
            })
          );

        if (body.estatusFinal === 4)
          // Cancelado con costo
          dispatch(
            startUpdateServicioGnp({
              folioAsignacion: body.folioGnp,
              estatusActual: gnp_estatus.NO_LOCALZIADO.clave,
            })
          );

        if (body.estatusFinal === 5)
          // Cancelado sin costo
          dispatch(
            startUpdateServicioGnp({
              folioAsignacion: body.folioGnp,
              estatusActual: gnp_estatus.CANCELADO.clave,
            })
          );
      }

      return { ok: true };
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - post concluir",
            `${result.error}`
          )
        )
      );
      return { ok: false, error: result.error };
    }
  };
};


//



//////////////////////////////////

// export const startPostConcluirServicio = (body) => {
//   return async (dispatch) => {
//     //
//     const url = `${URL_BASE_ASISTENCIAS}/ConcluirServicio`;
//     const result = await post(url, body);
//     //
//     if (result.code === 0) {
//       dispatch(startLoadAsistencia(body.asistenciaID, false));
//       dispatch(notification(composeSuccessNotification(result.data)));
//     } else {
//       dispatch(
//         notification(
//           composeErrorNotification(
//             "Error de conexion - post concluir",
//             `${result.error}`
//           )
//         )startPostConcluirServicio
//       );
//     }
//   };
// };
//////////////////////////////////

export const startUpdateFecha = (body) => {
  return async (dispatch) => {
    //
    const url = `${URL_BASE_ASISTENCIAS}/UpdateFecha`;
    const result = await post(url, body);
    //
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(composeErrorNotification("Error", `${result.error}`))
      );
    }
  };
};

///////////////

export const startPostDestino = (body) => {
  return async (dispatch, getState) => {
    //
    // const url = `${URL_BASE_ASISTENCIAS}/PostDestino`;
    const url = `${URL_ASISTENCIA_DESTINO}/PostDestino`;
    const result = await post(url, body);

    //
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));

      return result;
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Mapa destino",
            `${result.error}`
          )
        )
      );
    }
  };
};

////
export const setProveedorGeos = (geo) => ({
  type: types.setProveedorGeos,
  payload: geo,
});

export const clearProveedorGeos = () => ({
  type: types.clearProveedorGeos,
  payload: null,
});

export const getProveedorCostos = (sucursaLSelectedFromMap) => {
  return async (dispatch, getState) => {
    let sucursalFinalID = 0;
    const { servicioID, proveedorSucursalID } =
      getState().detalleReducer.asistencia;

    if (!sucursaLSelectedFromMap) sucursalFinalID = proveedorSucursalID;
    //
    // viene el state si ya se escogió proveedor
    else sucursalFinalID = sucursaLSelectedFromMap; // viene cuando picas en mapa

    // si no hay proveedor, a penas se va a buscar, no hay que hacer nada
    if (!sucursalFinalID) {
      dispatch(clearProveedorCostos());
      return;
    }

    //
    const body = {
      servicioID,
      proveedorSucursalID: sucursalFinalID,
    };

    const url = `${URL_BASE_ASISTENCIAS}/GetSucursalCostos`;
    const result = await post(url, body);

    //
    if (result.code === 0) {
      dispatch(storeProveedorCostos(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get costos",
            `${result.error}`
          )
        )
      );
    }
  };
};

const storeProveedorCostos = (data) => ({
  type: types.storeProveedorCostos,
  payload: data,
});

export const setProveedorPagoDirecto = (value) => ({
  type: types.setProveedorPagoDirecto,
  payload: value,
});

////////
export const startLoadHistorialAsignacion = (asistenciaID) => {
  return async (dispatch) => {
    dispatch(setLoadingHistorialAsignacion(true));
    const url = `${URL_BASE_ASISTENCIAS}/GetHistorialAsignacion/${asistenciaID}`;
    const result = await get(url);

    //
    if (result.code === 0) {
      dispatch(storeHistorialAsignacion(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get historial asignacion",
            `${result.error}`
          )
        )
      );
    }
    dispatch(setLoadingHistorialAsignacion(false));
  };
};

const storeHistorialAsignacion = (data) => ({
  type: types.storeHistorialAsignacion,
  payload: data,
});

const setLoadingHistorialAsignacion = (estado) => ({
  type: types.setLoadingHistorialAsignacion,
  payload: estado,
});
//////////////////////////////////

export const startPostComentarios = (body) => {
  return async (dispatch, getState) => {
    const { usuarioID, nombre } = getState().userReducer.user;
    const url = `${URL_BASE_ASISTENCIAS}/PostAsistenciaHistorial`;
    const result = await post(url, {
      ...body,
      usuarioID,
      usuarioNombre: nombre,
    });
    console.log(result.data);
    //
    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      dispatch(startGetHistorial(body.asistenciaID));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get costos",
            `${result.error}`
          )
        )
      );
    }
  };
};

export const startGetHistorial = (asistenciaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/GetAsistenciaHistorial/${asistenciaID}`;
    const result = await get(url);

    //
    if (result.code === 0) {
      dispatch(storeAsistenciaHistorial(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get historial asignacion",
            `${result.error}`
          )
        )
      );
    }
  };
};

const storeAsistenciaHistorial = (historial) => ({
  type: types.storeAsistenciaHistorial,
  payload: historial,
});

//////////////

export const startBloquearServicio = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/BloquearServicio`;
    const result = await post(url, body);

    //
    if (result.code === 0) {
      console.log("bloquedo");
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Post bloqueo",
            `${result.error}`
          )
        )
      );
    }
  };
};

export const startDesBloquearServicio = (asistenciaID) => {
  return async (dispatch) => {
    const body = {
      usuario: "",
      asistenciaID,
    };
    const url = `${URL_BASE_ASISTENCIAS}/BloquearServicio`;
    const result = await post(url, body);

    //
    if (result.code === 0) {
      console.log("desbloqueado");
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - Post bloqueo")
        )
      );
    }
  };
};

//////////////  Files

export const startGetAsistenciaFiles = (asistenciaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/GetDocumentos/${asistenciaID}`;
    const result = await get(url);

    //
    if (result.code === 0) {
      dispatch(storeAsistenciaFiles(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - Get documentos")
        )
      );
    }
  };
};

const storeAsistenciaFiles = (files) => ({
  type: types.storeAsistenciaFiles,
  payload: files,
});

///

export const startGetAsistenciaFile = (id, tipo, nombre) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/GetDocumento/${id}/${tipo}`;
    const nombreFinal = `${nombre}`;

    const result = await getFile(url, nombreFinal);

    if (result.code === -1) {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - Download documento A")
        )
      );
    }
  };
};

///////////////

export const startDownloadPlacas = (asistenciaID, nombrePlacas) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/GetDetalleDocumento/${asistenciaID}/${nombrePlacas}`;

    const result = await getFile(url, nombrePlacas);

    if (result.code === -1) {
      dispatch(notification(composeErrorNotification("GetDetalleDocumento")));
    }
  };
};

/////////////
export const startValidaProveedor = (asistenciaID) => {
  return async (dispatch, getState) => {
    const { usuarioID } = getState().userReducer.user;

    const url = `${URL_BASE_ASISTENCIAS}/ValidaProveedor`;

    const result = await post(url, { usuarioID, asistenciaID });

    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(
          composeErrorNotification("ValidaProveedor", `${result.error}`)
        )
      );
    }
  };
};

export const getDistanceBetweenPlaces = (origin, destiny) => {
  return async (dispatch) => {
    //  const result = await getDistance(origin, destiny);
    //  dispatch(actionSaveDistance(result));
  };
};

const actionSaveDistance = (payload) => ({
  type: types.saveDistance,
  payload,
});

// Desasignar ...

export const startDesasignaProveedor = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ASISTENCIAS}/DesasignaProveedor`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(composeErrorNotification("Desasignar", `${result.error}`))
      );
    }
  };
};

export const startGetEstatusAsistencia = (asistenciaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/EstatusAsistencia/${asistenciaID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(setEstatusAsistencia(result.data));
   
    }
  };
}

const setEstatusAsistencia = (data) => ({
  type: types.setEstatusAsistencia,
  payload: data,
});
////

export const startSetInicioAsignacion = (asistenciaID) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Cabina/InicioAsignacionUsuario`;
    const result = await post(url, { asistenciaID });

    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(startLoadAsistencia(asistenciaID, false));
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Inicia asignacion",
            `${result.error}`
          )
        )
      );
    }
  };
}

export const startGetUsuariosCabina = () => {
  return async (dispatch) => {
    const url = `${URL_CABINA_USUARIO_ASIGNACION}/GetUsuariosCabina`;
    const result = await get(url);
    return result;
  };
};

export const startGetUsuariosAsignacion = () => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/cabina/GetUsuariosAsignacion`;
    const result = await get(url);
    return result;
  };
};

export const startGetUsuariosSeguimiento = () => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/cabina/GetUsuariosSeguimiento`;
    const result = await get(url);
    return result;
  };
};

export const startSetUsuarioAsistencia = ({ asistenciaID, usuarioID }) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Cabina/InicioAsignacionUsuario`;
    const body = { asistenciaID, usuarioID };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error al asignar usuario",
            `${result.error}`
          )
        )
      );
    }

    return result;
  };
};

export const startSeguimiento = ({ asistenciaID, usuarioID }) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/Cabina/InicioSeguimientoUsuario`;
    const body = { asistenciaID, usuarioID };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(startLoadAsistencia(asistenciaID, false));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error al iniciar seguimiento",
            `${result.error}`
          )
        )
      );
    }

    return result;
  };
};

///


export const startNoProcedente = (body) => {
  return async (dispatch) => {
  
    const url = `${URL_BASE}/api/NoProcedente`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      dispatch(startLoadAsistencia(body.asistenciaID, false));
    } else {
      dispatch(
        notification(
          composeErrorNotification("NoProcedente", `${result.error}`)
        )
      );
    }
  };
}
